





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class AheadCombobox extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  // @Prop({ type: String }) schema!: string;
  // @Prop({ type: Array }) data!: any[];
  // @Prop({ type: String }) keyField!: string;
  // @Prop({ type: String }) labelField!: string;
  // @Prop({ type: String }) relField!: string;
  // @Prop({ type: String }) relFilter!: string;

  @Prop({ type: String }) clientId!: string;

  @Prop({ type: String }) position!: string;
  @Prop({ type: Boolean }) multiple!: boolean;

  @Prop({ type: String }) placeholder!: string;
  @Prop({ type: String }) typeFilter!: string;

  localValue: any = null
  selectdItemLabel: any = '';
  dropdownActive = false;

  items: any[] = [];
  itemsForDisplay: any[] = [];

  searchText: string = '';

  public created() {
    //
  }

  public mounted() {
    this.selectdItemLabel = this.placeholder;

    // if (this.schema) {
      this.loadData();
    // } else {
    //   this.items = this.data;
    //   this.onValueChange(this.value);
    //   this.updateDisplayList();
    // }
  }
// schema="products" key-field="id" label-field="name"
  public loadData() {
    const QNAME = `SELECT_COMBOBOX_LIST_PRODUCT`;

    this.$db([
      this.$q(QNAME)
        .select()
        .from('ahead_close_types')
        .fileds$((_: any) => {
          return {
            id: 'ahead_close_types.id',
            label: 'ahead_close_types.name',
            sub_label: 'ahead_close_sub_types.name',
            reasons: _.array_agg(
              _.obj({
                id: 'ahead_close_reasons.id',
                name: 'ahead_close_reasons.name'
              })
            )
          };
        })
        .leftJoin('ahead_close_sub_types', (_: any) => {
          return _.eq('ahead_close_sub_types.ahead_close_type_id', 'ahead_close_types.id')
        })
        .leftJoin('ahead_close_reasons', (_: any) => {
          return _.eq('ahead_close_sub_types.id', 'ahead_close_reasons.ahead_close_sub_type_id')
        })
        .order((_: any) => {
          return [
            _.asc(['ahead_close_sub_types.name'])
          ];
        })
        .group([
          'ahead_close_types.id',
          'ahead_close_types.name',
          'ahead_close_sub_types.name'
        ])

      .where((_: any) => {
        if(this.typeFilter) {
          return _.eq(`ahead_close_types.id`, _.const(this.typeFilter));
        } else {
          return undefined;
        }
      })
      // .limit(1000),
    ]).then(((result: ServerResult) => {
      this.items = result.getOperation(QNAME).getContent().documents.reduce((ac: any[], current: any) => {
        ac = [
          ...ac,
          {
            isGroup: true,
            label: `${current.sub_label} / ${current.label}`
          },
          ...current.reasons.map((item: any) => {
            return {
              id: item.id,
              label: item.name
            }
          })
        ]
        return ac
      }, []);
      console.log(this.items)

      if(this.multiple && !Array.isArray(this.value)) {
        this.onValueChange([this.value]);
      } else {
        this.onValueChange(this.value);
      }
      this.updateDisplayList()
    }));
  }

  @Watch('value')
  onValueChange(newVal: any) {
    // console.log(newVal);
    this.localValue = newVal;

    if (this.localValue) {
      if(Array.isArray(this.localValue)) {
        const selectdItems = this.items.filter((item) => this.localValue.includes(item.id));

        if (selectdItems.length > 0) {
          this.selectdItemLabel = selectdItems.map(item => item.label).join(', ');
        } else {
          this.selectdItemLabel = ''
        }

      } else {
        const selectdItem = this.items.find((item) => item.id == this.localValue);

        if (selectdItem) {
          this.selectdItemLabel = selectdItem.label;
        } else {
          this.selectdItemLabel = ''
        }
      }
    } else {
      this.selectdItemLabel = ''
    }
  }

  @Watch('relFilter')
  onRelFilterChange(newVal: any) {
    console.log('onRelFilterChange');
    this.updateValue(null);
    this.loadData();
  }

  updateValue(value: any) {
    this.onValueChange(value);
    this.$emit('input', value);

    if(Array.isArray(this.localValue)) {
        const selectdItems = this.items.filter((item) => this.localValue.includes(item.id));

        this.$emit('input-object', selectdItems);

      } else {
        const selectdItem = this.items.find((item) => item.id == this.localValue);

        this.$emit('input-object', selectdItem);
      }
  }

  activeChange($event: any) {
    this.dropdownActive = $event;
    console.log('this.dropdownActive', this.dropdownActive, this.$refs.searchInput);
    if (this.dropdownActive) {
      (this.$refs.searchInput as any).focus()
    }
  }

  @Watch('searchText')
  updateDisplayList() {
    this.$set(this, 'itemsForDisplay', (this.items || []).filter((item: any) => {
      return item.label.toLowerCase().includes(this.searchText);
    }))
  }

  // search($event) {
  //   throttle
  // }
}
